/**
 * A PERSON'S INVITE LINK — owner, 2026-10-19: Invite Friends 有兩種形式, 一種是使用邀請連結 … 每邀請到一個好朋友
 * 可以累積十個 Spark.
 *
 * `/?invite=<code>` (the BFF's INVCODE#). Kept the way a group's link is (groups/groupLink.ts), and for the same
 * reason — the person opening it is usually not signed in yet, and the sign-in round trip lands on "/" carrying
 * nothing of ours. The sign-in screen PEEKS at it to say who invited them; signed in, App TAKES it once and claims
 * it (acceptInvite). A day, then forgotten: long enough to make an account, short enough that a link opened and
 * abandoned does not claim someone else's sign-up a week later.
 */
const KEY = 'avg_invite_link'
const MAX_AGE_MS = 24 * 60 * 60 * 1000
const CODE = /^[A-Za-z0-9_-]{8,32}$/

export function captureInviteLink(): void {
  try {
    const q = new URLSearchParams(window.location.search)
    const code = q.get('invite')
    if (code === null) return
    if (CODE.test(code)) window.localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }))
    q.delete('invite')
    const rest = q.toString()
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest ? `?${rest}` : ''}${window.location.hash}`)
  } catch {
    /* no storage (private window): the link earns nothing, and the address is left as it was */
  }
}

function read(): string | null {
  try {
    const raw = window.localStorage.getItem(KEY)
    if (!raw) return null
    const { code, at } = JSON.parse(raw) as { code?: unknown; at?: unknown }
    if (typeof code !== 'string' || !CODE.test(code)) return null
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null
    return code
  } catch {
    return null
  }
}

/** The link this browser was opened with, left in place — the sign-in screen's question. */
export function peekInviteLink(): string | null {
  return read()
}

/** The link this browser was opened with, once — then it is gone. */
export function takeInviteLink(): string | null {
  const code = read()
  try {
    window.localStorage.removeItem(KEY)
  } catch {
    /* nothing kept, nothing to clear */
  }
  return code
}
